import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { ApplicationsBreadcrumb } from '../ApplicationsBreadcrumbs'
import { Suspense } from 'react'
import { AppAccessesPageContent } from './AppAccessesPageContent'

export function AppAccessesPage() {
  return (
    <>
      <ApplicationsBreadcrumb title="Accesses" />
      <QueryErrorBoundary errorMessage="Failed to fetch roles">
        <Suspense fallback={<DataTableLoading />}>
          <AppAccessesPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}
